export const EnumProcessingStatus = {
  NOT_PROCESSED: 'NOT_PROCESSED',
  PROCESSING: 'PROCESSING',
  PROCESSED: 'PROCESSED',
} as const;

export type EnumProcessingStatusType = keyof typeof EnumProcessingStatus;
